import { LaunchDarklyConfig } from "@/crossPlatform/LaunchDarkly/config";
import type {
  LaunchDarklyDeviceContext,
  LaunchDarklyInitialMultiContext,
} from "@/crossPlatform/LaunchDarkly/types";

export const createInitialMultiContext = (
  deviceContext: LaunchDarklyDeviceContext,
): LaunchDarklyInitialMultiContext => {
  return {
    device: {
      appVersion: deviceContext.appVersion,
      key: deviceContext.key,
      manufacturer: deviceContext.manufacturer,
      modelName: deviceContext.modelName,
      osName: deviceContext.osName,
      osVersion: deviceContext.osVersion,
    },
    kind: "multi",
    organization: {
      key: LaunchDarklyConfig.Key,
    },
  };
};
